import CampCategoryIndex from './CampCategoryIndex';
import CampCategoryCreate from './CampCategoryCreate';
import CampCategorySettings from './CampCategorySettings';
import CampCategorySingle from './CampCategorySingle';

export default function (app) {

    const settings = CampCategorySettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampCategoryIndex(app, settings);

    CampCategoryCreate(app, settings);

    CampCategorySingle(app, settings);

}